import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CTAButton({
  ariaLabel,
  buttonClass,
  buttonText,
  containerClass,
  icon,
  onClick,
  disabled,
  isLoading,
  role
}) {
  return (
    <div className={`flex ${containerClass}`}>
      <button
        className={classNames(
          'w-full text-sm md:text-base inline-block font-avenir-book rounded-md bg-primary-blue px-2 py-1 text-white shadow-sm hover:bg-navy-blue transition duration-150 ease-in-out',
          buttonClass,
          { 'cursor-not-allowed bg-opacity-50 hover:bg-opacity-50': disabled },
        )}
        type="submit"
        role={role || CTAButton.role}
        aria-label={ariaLabel}
        onClick={onClick}
        disabled={disabled}
      >
        <div className="flex justify-center items-center">
          <span className="hidden xs:inline flex justify-center items-center">
            {icon && !isLoading && (
              <FontAwesomeIcon icon={icon} className="mr-2 mt-1 text-sm" />
            )}
            {isLoading && (
              <FontAwesomeIcon className="mr-2 mt-1" icon="spinner" spin />
            )}
          </span>
          <span>{buttonText}</span>
        </div>
      </button>
    </div>
  );
}

CTAButton.role = 'cta-button-component';
